import { useEffect, useRef } from "react";

/**
 * A detail shown as a page over its list on a phone. Opening it adds a history entry, so the back
 * gesture closes it; `key` names the entry so pages of different views never close each other.
 */
export function usePhoneDetail(narrow: boolean, key: string, onClose: () => void) {
	const close = useRef(onClose);
	close.current = onClose;
	const isOpen = () => (history.state as Record<string, unknown> | null)?.[key] === 1;
	useEffect(() => {
		if (!narrow) return;
		const onPop = () => {
			if (!isOpen()) close.current();
		};
		addEventListener("popstate", onPop);
		return () => removeEventListener("popstate", onPop);
	}, [narrow, key]);
	return {
		/** Call once a detail opened from the list. */
		opened: () => {
			if (narrow && !isOpen()) history.pushState({ [key]: 1 }, "");
		},
		back: () => {
			if (narrow && isOpen()) history.back();
			else close.current();
		},
	};
}
